jQuery(function ($) {
    $(document).ready(function () {
        if (!$('div').hasClass('giza-template')) {
            if ($('div').hasClass('page-template-template-home-new')) {
                $('.owl-carousel').owlCarousel({
                    loop: true,
                    nav: true,
                    autoplay: true,
                    autoplayTimeout: 5000,
                    dots: false,
                    responsiveClass: true,
                    margin: 30,
                    responsive: {
                        0: {
                            items: 1,
                            margin: 15,
                            stagePadding: 50
                        },
                        480: {
                            items: 1,
                            margin: 30,
                            stagePadding: 100
                        },
                        768: {
                            items: 2,
                            margin: 30,
                            stagePadding: 100
                        },
                        992: {
                            items: 3,
                            margin: 30,
                            stagePadding: 100
                        },
                        1025: {
                            items: 4,
                            margin: 30,
                            stagePadding: 100
                        }
                    },
                })
            } else {
                $('.owl-carousel').owlCarousel({
                    loop: true,
                    margin: 0,
                    nav: false,
                    autoplay: true,
                    autoplayTimeout: 3000,
                    dots: true,
                    responsiveClass: true,

                    responsive: {
                        0: {
                            items: 1
                        },
                        600: {
                            items: 1
                        },
                        1000: {
                            items: 1
                        }
                    },
                    onTranslated: callback,
                    onInitialized: callback,
                })
                function callback(event) {
                    var items = $('.owl-carousel').find('.owl-item');

                    items.attr('aria-hidden', 'true');
                    items.attr('tabindex', '-1');

                    items.eq(event.item.index).attr('aria-hidden', 'false');
                    items.eq(event.item.index).attr('tabindex', '0');
                }



            }

        } else {
            var sync1 = $("#mainproductslider");
            var sync2 = $("#secondproductslider");
            var slidesPerPage = 4; //globaly define number of elements per page
            var syncedSecondary = true;

            sync1.owlCarousel({
                items: 1,
                slideSpeed: 2000,
                nav: false,
                autoplay: true,
                dots: true,
                loop: true,
                responsiveRefreshRate: 200,
                onTranslated: callback,
                onInitialized: callback,
            }).on('changed.owl.carousel', syncPosition);
            function callback(event) {
                var items = $('#mainproductslider').find('.owl-item');

                items.attr('aria-hidden', 'true');
                items.attr('tabindex', '-1');

                items.eq(event.item.index).attr('aria-hidden', 'false');
                items.eq(event.item.index).attr('tabindex', '0');
            }
            sync2
                .on('initialized.owl.carousel', function () {
                    sync2.find(".owl-item").eq(0).addClass("current");
                })
                .owlCarousel({
                    // items: slidesPerPage,
                    items: 3,
                    dots: false,
                    nav: false,
                    smartSpeed: 200,
                    slideSpeed: 500,
                    slideBy: slidesPerPage, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
                    responsiveRefreshRate: 100,
                    autoWidth: true,
                }).on('changed.owl.carousel', syncPosition2);



            sync2.data('owl.carousel').difference = function (first, second) {
                return {
                    x: first.x - second.x + (first.y - second.y),
                    y: first.y - second.y
                };
            };

            function syncPosition(el) {
                //if you set loop to false, you have to restore this next line
                //var current = el.item.index;

                //if you disable loop you have to comment this block
                var count = el.item.count - 1;
                var current = Math.round(el.item.index - (el.item.count / 2) - .5);

                if (current < 0) {
                    current = count;
                }
                if (current > count) {
                    current = 0;
                }

                //end block

                sync2
                    .find(".owl-item")
                    .removeClass("current")
                    .eq(current)
                    .addClass("current");
                var onscreen = sync2.find('.owl-item.active').length - 1;
                var start = sync2.find('.owl-item.active').first().index();
                var end = sync2.find('.owl-item.active').last().index();

                if (current > end) {
                    sync2.data('owl.carousel').to(current, 100, true);
                }
                if (current < start) {
                    sync2.data('owl.carousel').to(current - onscreen, 100, true);
                }
            }

            function syncPosition2(el) {
                if (syncedSecondary) {
                    var number = el.item.index;
                    sync1.data('owl.carousel').to(number, 100, true);
                }
            }

            sync2.on("click", ".owl-item", function (e) {
                e.preventDefault();
                var number = $(this).index();
                sync1.data('owl.carousel').to(number, 300, true);
            });
        }
    })
})
